export const IFRAME_MESSAGE_TYPES = {
  SUCCESS: 'SUCCESS'
};